import Form from "@ant-design/compatible/es/form";
import { UserOutlined } from "@ant-design/icons";
import FormCard from "@impero-com/common/components/formCard";
import FormCardContainer from "@impero-com/common/components/formCardContainer";
import { t } from "@impero-com/common/utils/i18n";
import { isEmailValid } from "@impero-com/common/utils/isEmailValid";
import { Button, CardFooter, FormSubtitle, FormTitle } from "@impero-com/ui";
import { Input } from "antd";

import RightSideText from "./rightSideText";
import * as theme from "./theme.css";

const FormItem = Form.Item;

const ForgotPassword = (props: any) => {
    const { getFieldDecorator } = props.form;
    return (
        <FormCardContainer rightSide={<RightSideText />}>
            <FormTitle title={t("LoginFlow_ForgotYourPassword")} />
            <FormSubtitle subtitle={t("LoginFlow_ResetPasswordEmail")} />
            <FormCard>
                <FormItem>
                    {getFieldDecorator("email", {
                        rules: [
                            {
                                required: true,
                                message: t("LoginFlow_InputCorrectEmail"),
                            },
                            {
                                validator: (
                                    _rule: any,
                                    value: string | undefined,
                                    callback: any
                                ) => {
                                    if (!isEmailValid(value)) {
                                        callback(
                                            t("LoginFlow_InputCorrectEmail")
                                        );
                                    } else {
                                        callback();
                                    }
                                },
                            },
                        ],
                    })(
                        <Input
                            prefix={
                                <UserOutlined className={theme.iconOpacity} />
                            }
                            placeholder={t("Login_UserName")}
                        />
                    )}
                </FormItem>
                <FormItem>
                    <Button
                        id="loginFormSubmitBtn"
                        variant="primary"
                        type="submit"
                        block
                    >
                        {t("LoginFlow_SendMeAnEmail")}
                    </Button>
                </FormItem>
            </FormCard>

            <CardFooter>
                <a href="https://impero.com/get-in-touch/" target="_blank">
                    {t("LoginFlow_DontHaveAccount")}
                </a>
            </CardFooter>
        </FormCardContainer>
    );
};

export default ForgotPassword;
